import { Injectable } from '@angular/core';
import { UserDetails } from '../models/user-details';
import { CommonService } from './common.service';
import { DataService } from './data.service';
import { Matter } from '../models/matter';
import { ActionParticipant, Participants, Disbursements, formatClientName } from '../models/participants';

@Injectable({
    providedIn: 'root'
})
export class MatterService {
    url = "api/matters";

    constructor(
        private dataService: DataService,
        private commonService: CommonService,
    ) { }

    async getMatterList(id: string, name: string): Promise<Matter[]> {
        let queryParams: string[] = [];

        if (id) {
            queryParams.push(`id=${encodeURIComponent(id)}`);
        }

        if (name) {
            queryParams.push(`name=${encodeURIComponent(name)}`);
        }

        const url = queryParams.length > 0
            ? `${this.url}?${queryParams.join("&")}`
            : this.url;

        return await this.dataService.get<Matter[]>(url);    }

     getMatterClient(action: number, participantType: number) {
        return  this.dataService.get<Participants[]>(this.url + "/participants" + "?action=" + action + "&participantType=" + participantType);
    }

    /**
     * The distinct names of the clients on a matter, as "First Last". A matter with more than one client returns more
     * than one name. Actionstep's display name is "Last, First", so people are rebuilt from their first and last names;
     * a client with no first and last name (a company, say) keeps its display name.
     */
    async getMatterClientNames(matterNumber: number): Promise<string[]> {
        const clients = await this.getMatterClient(matterNumber, 27);
        const names = (clients ?? []).map(formatClientName).filter(name => !!name);
        return [...new Set(names)];
    }

    getMatterListByParticipant(participantId: number): Promise<Matter[]> {
        return this.dataService.get<Matter[]>(`${this.url}/byparticipant/${participantId}`);
    }

    getDisbursementList(matterId: number) {
        return this.dataService.get<Disbursements[]>(`${this.url}/${matterId}/disbursements`);
    }
}
